import { WeekOption } from "../../features/admin/earning/previous-week/previous-week.component";
import { ApprovalStatusList, USER_DOCUMENT_AND_IMAGES_TYPES } from "../constants/app-constants";
import { WeekRangeType } from "../enums/week-range-type.enum";
import { ApprovalStatus } from "../interfaces/generalinterface/approval-status.interface";
import { UserDocumentAndImagesType } from "../interfaces/user-document-interfaces/user-document-and-image-type.interface";

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';


export function getApprovalStatusById(id: number): ApprovalStatus | undefined {
    return ApprovalStatusList.find((status) => status.id === id);
}

export function getUserDopcumentAndImageTypeById(id: number): UserDocumentAndImagesType | undefined {
    return USER_DOCUMENT_AND_IMAGES_TYPES.find((status) => status.id === id);
}


export function checkIfNearToExpire(expiryDate: string | Date | null |undefined, nearDays = 30) {

    if(!expiryDate){
        return {
            isExpired: false,
            isNearToExpire: false,
            remainingDays:0
        }
    }
    const expiry = new Date(expiryDate);
    const now = new Date();

    //const diffInMs = expiry.getTime() - now.getTime();
   // const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            const diffInDays = (expiry.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0)) / (1000 * 60 * 60 * 24);
 
    return {
        isExpired: diffInDays < 0,
        isNearToExpire: diffInDays >= 0 && diffInDays <= nearDays,
        remainingDays: Math.floor(diffInDays)
    };
}

export function getHoursBetweenDates(startDate: Date | string, endDate: Date | string = new Date()): number {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffMs = end.getTime() - start.getTime(); // difference in milliseconds
    const diffHours = diffMs / (1000 * 60 * 60);    // convert to hours
 
    return diffHours;
}
export function getWeekRange(type: WeekRangeType): { startDate: Date; endDate: Date } {
    const today = new Date();

    // get Monday of the current week
    const dayOfWeek = today.getDay();   // Sun=0, Mon=1, ... Sat=6
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const currentWeekMonday = new Date(today);
    currentWeekMonday.setDate(today.getDate() + mondayOffset);
    currentWeekMonday.setHours(0, 0, 0, 0);

    const currentWeekSunday = new Date(currentWeekMonday);
    currentWeekSunday.setDate(currentWeekMonday.getDate() + 6);
    currentWeekSunday.setHours(23, 59, 59, 999);

    let startDate = new Date(currentWeekMonday);
    let endDate = new Date(currentWeekSunday);

    switch (type) {
        case WeekRangeType.CURRENT_WEEK:
            break;
        case WeekRangeType.TODAY:
            startDate = new Date();
            endDate.setDate(startDate.getDate() + 2);
            break;
        case WeekRangeType.LAST_WEEK:
            startDate = new Date(currentWeekMonday);
            startDate.setDate(startDate.getDate() - 7);

            endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + 6);
            endDate.setHours(23, 59, 59, 999);
            break;

        case WeekRangeType.FOUR_WEEKS:
            // 4 full weeks ago (Mon → Sun)
            startDate = new Date(currentWeekMonday);
            startDate.setDate(startDate.getDate() - 28);

            endDate = new Date(currentWeekSunday);
            endDate.setDate(endDate.getDate() - 1); // end of last full 4-week period
            break;

        default:
            throw new Error('Invalid WeekRangeType passed.');
    }

    return { startDate, endDate };
}



const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

const MONTH_SHORT = [
    'jan', 'feb', 'mar', 'apr', 'may', 'jun',
    'jul', 'aug', 'sept', 'oct', 'nov', 'dec'
];

function formatLabelDate(date: Date): string {
    const monthName = MONTH_NAMES[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${monthName} ${day}, ${year}`;
}

// "9/22/2025 11:45:00 AM"
function formatStartEndDate(date: Date,isStartDate:boolean=true): string {
    const month = date.getMonth() + 1; // 1-12
    const day = date.getDate();        // no leading zero, matches your sample
    const year = date.getFullYear();
    if(isStartDate){
    return `${month}/${day}/${year} 12:00:00 AM`;
    }else{

    return `${month}/${day}/${year} 11:59:59 PM`;
    }
}

// "sept22-28" or "july28-aug3"
function buildValueSlug(start: Date, end: Date): string {
    const startMonth = MONTH_SHORT[start.getMonth()];
    const endMonth = MONTH_SHORT[end.getMonth()];

    if (startMonth === endMonth) {
        return `${startMonth}${start.getDate()}-${end.getDate()}`;
    }

    return `${startMonth}${start.getDate()}-${endMonth}${end.getDate()}`;
}


export function buildWeekOptionsFromNov2ToCurrent(): WeekOption[] {
    const options: WeekOption[] = [];

    // 1) Start from Sunday, Nov 2, 2025
    let weekEnd = new Date(2025, 10, 2); // month 10 = November
    weekEnd.setHours(0, 0, 0, 0);

    // 2) Find Sunday of current week (upcoming or today if it's Sunday)
    const today = new Date();
    const current = new Date(today);
    current.setHours(0, 0, 0, 0);

    const day = current.getDay(); // 0=Sun..6=Sat
    const sundayOffset = day === 0 ? 0 : 7 - day;
    const currentWeekSunday = new Date(current);
    currentWeekSunday.setDate(currentWeekSunday.getDate() + sundayOffset);
    currentWeekSunday.setHours(0, 0, 0, 0);

    // 3) Loop from week ending on Nov 2 → current week Sunday
    while (weekEnd <= currentWeekSunday) {
        const weekStart = new Date(weekEnd);
        weekStart.setDate(weekEnd.getDate() - 6); // Monday
        weekStart.setHours(0, 0, 0, 0);

        const label = `${formatLabelDate(weekStart)} - ${formatLabelDate(weekEnd)}`;
        const startDateStr = formatStartEndDate(weekStart);
        const endDateStr = formatStartEndDate(weekEnd,false);
        const value = buildValueSlug(weekStart, weekEnd);

        options.push({
            label,
            startDate: startDateStr,
            endDate: endDateStr,
            value,
        });

        // move to next week (next Sunday)
        weekEnd = new Date(weekEnd);
        weekEnd.setDate(weekEnd.getDate() + 7);
    }

    return options.reverse(); // reverse to have most recent week first
}
